import React from 'react';

export default function WhatsNewMain(): JSX.Element {
	return (
		<div className="whats-new-container">
			<h1>What's New</h1>
		</div>
	);
}